import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface SidebarSectionProps {
  label?: string;
  collapsed?: boolean;
  children: ReactNode;
}

export function SidebarSection({ label, collapsed, children }: SidebarSectionProps) {
  return (
    <div className="space-y-1">
      {label && !collapsed && (
        <div
          className={cn(
            "px-3 pt-4 pb-1 text-[10px] font-semibold uppercase tracking-[0.2em]",
            "text-foreground/40"
          )}
        >
          {label}
        </div>
      )}
      {label && collapsed && (
        <div className="mx-3 my-2 h-px [background-color:hsl(var(--glass-tint)/0.07)]" aria-hidden="true" />
      )}
      <div className="space-y-0.5">{children}</div>
    </div>
  );
}
